import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './index';

// Pre-typed hooks — use these everywhere instead of the plain hooks.
// They carry the correct store types without needing to repeat them.
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T): T =>
  useSelector<RootState, T>(selector);
